import importer from 'common/importer'
/* NAVIGATOR */
const { navigate, ROUTES } = importer('NavigationService', null)
/* ALERT */
const alert = importer('Helpers/Alert')
export default function * failure ({ error }) {
  // console.log(JSON.stringify(error))
  if (error.response) {
    const { data } = error.response
    if (data.error_description) {
      yield alert(
        'Login Error',
        `An error has occurred with Login[3]\n
      ${data.error_description}`
      )
    } else {
      yield alert(
        'Login Error',
        'An error has occurred with Login[3]'
      )
    }
  }
  //Keep the below code as it is, till Login[3] error exists
  yield navigate(ROUTES.DonorDashboard)
}
